import {has} from '@malt/common';

export function mixin(out, ...args) {
    out = out || {};

    for (let i = 0; i < args.length; i++) {
        if (!args[i]) {
            continue;
        }

        for (const key in args[i]) {
            if (has(args[i], key)) {
                out[key] = args[i][key];
            }
        }
    }

    return out;
}
